import styled from 'styled-components';
import { getStateColor } from "../../utils/getStateColor";
export const PillContainer = styled.button`
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  text-overflow: ellipsis;
  overflow: hidden;
  border: ${_ref => {
  let {
    theme,
    variant,
    color
  } = _ref;
  return variant === 'outline' ? `2px solid ${color ?? theme.colors.secondaryD1}` : '2px solid transparent';
}};

  height: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size === 'xs' ? '28px' : size === 'sm' ? '40px' : '28px';
}};

  background-color: ${_ref3 => {
  let {
    theme,
    variant,
    color
  } = _ref3;
  if (variant === 'filled') {
    return getStateColor(color ?? theme.colors.primary, 'normal');
  } else if (variant === 'outline' || variant === 'ghost') {
    return 'transparent';
  } else {
    return theme.colors.secondaryD1;
  }
}};

  padding: ${_ref4 => {
  let {
    size
  } = _ref4;
  return size === 'xs' ? '4px 6px' : size === 'sm' ? '8px 10px' : '4px 6px';
}};

  cursor: ${_ref5 => {
  let {
    clickable
  } = _ref5;
  return clickable ? 'pointer' : 'default';
}};

  transition: 0.2s;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }

  &:not(:disabled):hover {
    transition: 0.2s;
    background-color: ${_ref6 => {
  let {
    theme,
    color
  } = _ref6;
  return getStateColor(color ?? theme.colors.primary, 'hover');
}};
  }

  &:not(:disabled):active {
    transition: 0.2s;
    background-color: ${_ref7 => {
  let {
    theme,
    color
  } = _ref7;
  return getStateColor(color ?? theme.colors.primary, 'pressed');
}};
  }
`;
export const PillLabel = styled.div`
  margin: 0 4px;
  color: ${_ref8 => {
  let {
    theme,
    labelColor
  } = _ref8;
  return labelColor ?? theme.colors.neutralL5;
}};
  ${_ref9 => {
  let {
    theme,
    size
  } = _ref9;
  return size === 'xs' ? theme.fonts.titleXS : size === 'sm' ? theme.fonts.titleMD : theme.fonts.titleXS;
}}
  user-select: none;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
export const PillDecorator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${_ref10 => {
  let {
    size
  } = _ref10;
  return size === 'xs' ? '20px' : size === 'sm' ? '24px' : '20px';
}};
  height: ${_ref11 => {
  let {
    size
  } = _ref11;
  return size === 'xs' ? '20px' : size === 'sm' ? '24px' : '20px';
}};
`;
export const PillDelete = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0;
  background-color: transparent;
  cursor: pointer;
`;